import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import PBMTable from './components/PBMTable';

const PBMList = () => {
  const navigate = useNavigate();

  return (
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <Typography variant="h4" gutterBottom>PBMs</Typography>
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => navigate('/pbm/add')}
            >
                Add PBM
            </Button>
        </Box>
        <PBMTable />
      </Box>
    
  );
};

export default PBMList;

